module.exports = __webpack_public_path__ + "static/media/135.ca5e1c42.webp";